export default [
  {
    path: "/cabinet",
    name: "Cabinet",
    component: () => import("@/modules/cabinet/views/CabinetView.vue"),
    children: [
      {
        path: "orders",
        name: "CabinetOrders",
        component: () => import("@/modules/orders/components/OrdersList.vue"),
        meta: { title: "Мои заказы" },
      },
      {
        path: "orders/:id",
        name: "CabinetOrderDetails",
        component: () => import("@/modules/orders/components/OrderDetails.vue"),
        meta: { title: "Детали заказа" },
      },
    ],
  },
  {
    path: "/my-stats",
    name: "myStats",
    component: () => import("@/modules/cabinet/views/MyStatsPage.vue"),
    meta: { requiresAuth: true, roles: ["Manager", "Admin", "God"] },
  },
];